import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { computed, ref } from 'vue';
import { IConfig } from '~/utils/sanityImage';


export default /*#__PURE__*/_defineComponent({
  __name: 'SanityResponsiveImage',
  props: {
    config: null,
    alt: null,
    lazy: { type: [String, Boolean], default: 'lazy' }
  },
  setup(__props: any) {

const props = __props as { config: IConfig, alt?: string, lazy: 'lazy' | 'eager' | false }



const { $sanityImage } = useContext();
const imageProps = computed(() => $sanityImage.imageProps(props.config));
const isLoaded = ref(false);

return { __sfc: true,props, $sanityImage, imageProps, isLoaded }
}

})